export default "__VITE_ASSET__CtzwmKk0__"